<header>
  <nav class="navbar p-0 navbar-expand-lg fixed-top" [class.menu-escondido]="compartilhadoService.ocultarMenu" [class.menu-aberto]="!compartilhadoService.ocultarMenu">

    <div class="row m-0 w-100 align-items-center justify-content-end">
      <div class="col-3 p-0">
        <div class="row m-0 mt-4 mb-4">
          <div class="col-12 text-center logo d-flex">
            <img src="../../../../assets/svg/logo-home.svg" alt="">
          </div>
        </div>
      </div>
      <div class="col-9 p-0 d-flex text-right justify-content-end align-items-center">
        <div class="info-usuario">
          <div class="avatar-container" title="Sair">
            <span class="iniciais">{{ iniciais }}</span>
            <img src="../../../../assets/icons/avatar.svg" alt="Avatar do usuário">
          </div>
          <div class="dados-usuario">
            <label class="nome">{{ nome }}</label>
            <label class="email">{{ email }}</label>
          </div>
        </div>
        <div class="barra"></div>
        <div class="area-sair" (click)="abrirModalLogout()">
          <img src="../../../../assets/icons/log-out.svg" title="Sair">
          <p>Sair</p>
        </div>
      </div>
    </div>
  </nav>
</header>

<app-modal-confirmacao-mensagem [opts]="opts" (confimarDialogo)="confimarDialogo()">
</app-modal-confirmacao-mensagem>